
<div class="inner-row-datawr fl-row">
  <div class="col-4-left-inner col-sm-4">
    <div class="card-data compliance-gap-box">
      <div class="card-heading fl-row">
        <div class="heading-text">
          <h5>{{ 'Compliance Status' | translate }}</h5>
        </div>
        <div class="heading-more">
          <span class="material-icons">more_vert</span>
        </div>
      </div>
      <div class="card-box-dd fl-row">
        <div class="status-col">
          <p>{{ 'Dust' | translate }}</p>
          <div class="status-fig">
            <img src="../../../assets/images/dust-icon.jpg">
          </div>
        </div>
        <div class="status-col">
          <p>{{ 'Noise' | translate }}</p>
          <div class="status-fig">
            <img src="../../../assets/images/noise-icon.jpg">
          </div>
        </div>
        <div class="status-col">
          <p>{{ 'Gas' | translate }}</p>
          <div class="status-fig">
            <img src="../../../assets/images/gas-icon.jpg">
          </div>
        </div>
      </div>

      <div class="InstructionCard">
        <div class="InstructionCardInner">
          <img class="cross-button" (click)="flyOut('')"
            src="../../../../assets/images/close.png">
            <h4>{{ 'Compliance Status' | translate }}</h4>
            <p>{{ 'This area shows you the overall exposure status of your work or factory site.' | translate }}</p>
            <div class="NextPreviewTabs">
              <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button" class="btn btn-secondary PreviousButton">
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
                <button type="button" (click)="flyOut('ActiveAlarmNotification', 999999)"
                  class="btn btn-secondary active NextButton">
                  <i class="fa fa-arrow-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (employee_stats) {
        <div class="row col-md-12 height-80 mt-5 mb-5">
          <div class="col-md-6 h-100">
            <div class="row pl-4 custom-grey-h2">
              <span class="text-grey text-left">{{ 'Employees with Over' | translate }} <br/> {{ 'Exposure Risk' | translate }}</span>
            </div>
            <div class="row mt-2 pl-4">
              <span class="custom-black-h2">{{employee_stats?.exposure_risk ? employee_stats?.exposure_risk : 0}}</span>
            </div>
          </div>
          <div class="col-md-6 border-left h-100 text-center">
            <div class="row pl-4 custom-grey-h2">
              <span class="text-grey text-left">{{ 'Employees as' | translate }} <br/> {{ 'Active EPs' | translate }}</span>
            </div>
            <div class="row mt-2 pl-4">
              <span class="custom-black-h2">{{employee_stats?.active_endpoints ? employee_stats?.active_endpoints : 0}}</span>
            </div>
          </div>
        </div>
      }

      @if (average_exposure) {
        <div class="card-data card-top-margin col-height">
          <div class="card-heading fl-row">
            <div class="heading-text">
              <h5 class="header-font">{{ 'Average Exposure' | translate }}</h5>
            </div>
          </div>
          <div class="card-box-dd">
            <div class="fl-row no-gutters height-fit-content">
              <div class="col-md-6 col-sm-6 col-6">
                <div style="height: 200px;">
                  <div class=" pl-2 pt-5">
                    <strong><span>{{ 'Dust' | translate }} <br/>{{ 'Exposure' | translate }}</span></strong>
                  </div>
                  <div class="vertical-align-middle pl-2 pt-5">
                    <span class="text-grey text-small">Respirable PM &nbsp;</span>
                  </div>
                  <div class="vertical-align-middle pl-2">
                    <strong><span class="text-black">{{average_exposure?.respirable_pm ? employee_stats?.respirable_pm : 0}} &nbsp;</span></strong>
                    <span class="material-icons">info</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-6">
                <div class="vertical-align-middle pt-2 items-align-middle">
                  <div id="gaugeChart3" style="width: 100%; height: 200px"></div>
                </div>
              </div>
            </div>
            <hr class="field-underline"/>
            <div class="fl-row no-gutters height-fit-content">
              <div class="col-md-6 col-sm-6 col-6">
                <div style="height: 200px;">
                  <div class=" pl-2 pt-5">
                    <strong><span>{{ 'Noise' | translate }} <br/>{{ 'Exposure' | translate }}</span></strong>
                  </div>
                  <div class="vertical-align-middle pl-2 pt-5">
                    <strong><span class="text-black">{{average_exposure?.noise_exposure ? employee_stats?.noise_exposure : 0}} &nbsp;</span></strong>
                    <span class="material-icons show-info">info</span>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-6">
                <div class="vertical-align-middle pt-2 items-align-middle">
                  <div id="gaugeChart4" style="width: 100%; height: 200px;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

    </div>

    <div class="col-8-right col-sm-8 pl-2">
      <div class="AlarmNotificationOuter" [ngStyle]="{'z-index': zIndex}">
        <div class="AlarmNotification d-flex align-items-center justify-content-between">
          <div class="AlarmNotificationLeft  d-flex align-items-center">
            <div class="AlertIcon">
              <svg width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd">
                  <path d="M0 0h29v29H0z" />
                  <path
                    d="M12.676 5.105a2.4 2.4 0 0 1 3.302.787l8.998 14.627a2.4 2.4 0 0 1-2.045 3.657H4.936a2.4 2.4 0 0 1-2.044-3.657L11.89 5.892a2.4 2.4 0 0 1 .786-.787zm2.466 13.385h-2.417v2.275h2.417V18.49zm0-6.823h-2.417v4.549h2.417v-4.55z"
                    [attr.fill]="colors.greyLight" fill-rule="nonzero" />
                  </g>
                </svg>
              </div>
              <div class="AlertContent">
                <p class="m-0">You have 6 Alarms that need attention</p>
              </div>
            </div>
            <div class="AlarmNotificationRight">
              <svg width="10" height="11" viewBox="0 0 10 11" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m6.535 5.512 3.484 3.28-1.589 1.495-3.484-3.28-3.43 3.23-1.517-1.428L3.43 5.58-.055 2.301 1.534.806l3.484 3.28L8.484.822l1.517 1.427z"
                  [attr.fill]="colors.red" fill-rule="nonzero" />
                </svg>
              </div>
            </div>
            <div class="InstructionCard AlarmNotificationIns">
              <div class="InstructionCardInner">
                <img class="cross-button" (click)="flyOut('')"
                  src="../../../../assets/images/close.png">
                  <h4>{{ 'Alerts - Need Attention' | translate }}</h4>
                  <p>{{ 'This is where incidents requiring your urgent attention will be listed.' | translate }} </p>
                  <div class="NextPreviewTabs">
                    <div class="btn-group" role="group" aria-label="Basic example">
                      <button (click)="flyOut('ActiveCompliance')" type="button"
                        class="btn btn-secondary PreviousButton active">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                      </button>
                      <button (click)="flyOut('ActiveEndPoint')" type="button"
                        class="btn btn-secondary active NextButton">
                        <i class="fa fa-arrow-right" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <app-workforce-table></app-workforce-table>
          </div>
        </div>

        <div class="overlay" (click)="hideView()" [ngStyle]="{'display' : (workforceInfoOpen) ? 'block' : 'none'}"></div>

